export const environment = {
  production: false,
  hmr: true,
  productionDomain: "http://api.ganatak.com/public/api/",
  developmentDomain: "http://api.ganatak.com/public/api/",
};
